import { Link, useNavigate } from '@tanstack/react-router';
import { Button, Pill, TableCell, TableRow } from '@/shared/components';
import { I } from '@/shared/icons';
import type { PropertyGroupResponse } from '@/shared/api';
import { lifecycleSummary } from './objectOverview';

interface ObjectListRowProps {
  group: PropertyGroupResponse;
  canManage: boolean;
}

export function ObjectListRow({ group, canManage }: ObjectListRowProps) {
  const navigate = useNavigate();
  const summary = lifecycleSummary(group);
  return (
    <TableRow>
      <TableCell>
        <Link
          to="/property-groups/$id"
          params={{ id: group.id }}
          className="focus-visible:ring-sage text-ink rounded-sm font-medium hover:underline focus-visible:outline-none focus-visible:ring-2"
        >
          {group.name}
        </Link>
        <p className="text-ink-faint text-xs">{group.address.street}</p>
      </TableCell>
      <TableCell className="text-ink-soft">
        {group.address.postalCode} {group.address.city}
      </TableCell>
      <TableCell>
        {group.needsAddressReview ? (
          <Pill variant="warning" size="sm">
            Prüfung nötig
          </Pill>
        ) : (
          <span className="text-ink-faint text-sm">—</span>
        )}
      </TableCell>
      <TableCell>
        <span className="text-ink text-sm">{group.visibleApartmentCount}</span>
        {summary && <span className="text-ink-faint ml-2 text-xs">{summary}</span>}
      </TableCell>
      <TableCell className="text-right">
        {canManage && (
          <Button
            variant="ghost"
            size="sm"
            leftIcon={<I name="Edit" size={14} />}
            onClick={() => void navigate({ to: '/property-groups/$id', params: { id: group.id } })}
          >
            Bearbeiten
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
}
